const BASE_FORM = {
  'type': 'Tipo TWC',
  'numTwcDealer': 'Número TWC',
  'orderRepairId': 'Número de orden de reparación',
  'chassis': 'VIN Chasis',
  'condition': 'Condición',
  'cause': 'Causa',
  'repair': 'Reparación',
  'task1': 'T1',
  'task2': 'T2',
  'operationType': 'Tipo de operación',
};

const ADMIN_DATES_FORM = {
  'createDate': 'Fecha de Reclamo',
  'salesDate': 'Fecha de venta del vehículo',
  'repairDate': 'Fecha de Reparación',
};

const BASE_FORM_CAMPAIGN = {
  'type': 'Tipo TWC',
  'numTwcDealer': 'Número TWC',
  'orderRepairId': 'Número de orden de reparación',
  'chassis': 'VIN Chasis',
  'operationType': 'Tipo de operación',
  'campaignId': 'Campaña',
};

export const errorFields = (campaignFlag) => {
  const formFields = campaignFlag ? BASE_FORM_CAMPAIGN : BASE_FORM;
  return {
    ...formFields,
    ...ADMIN_DATES_FORM,
  };
};

export const ERROR_EXCEL_FIELDS = {
  'dealerId': 'Codigo del distribuidor',
  'reclaimCode': 'Codigo del Reclamante',
  'operationType': 'Tipo de operacion',
  'numTwcDealer': 'Número TWC',
  'numFac': 'Número de Factura',
  'orderRepairId': 'Número de orden de reparacion',
  'chassis': 'chasis',
  'salesDate': 'Fecha de venta del vehículo',
  'km': 'kilometraje',
  'repairDate': 'Fecha de reparacion',
  'actualDate': 'Fecha actual',
  'processDate': 'Fecha de proceso inicial',
  'openRepairDate': 'Fecha de Apertura de Reparación',
  'endRepairDate': 'Fecha de Finalización de la Reparación',
  'condition': 'Condición',
  'taskId': 'No. de Operación',
  'hours': 'Número de horas',
};

export const errorExcelFields = (line) => {
  const extraFields = {
    ...(line.partNo2) && ({'partNo2': 'No. de parte 2', 'quantity2': 'Cantidad 2'}),
    ...(line.partNo3) && ({'partNo3': 'No. de parte 3', 'quantity3': 'Cantidad 3'}),
    ...(line.partNo4) && ({'partNo4': 'No. de parte 4', 'quantity4': 'Cantidad 4'}),
  };
  return {
    ...extraFields,
    ...ERROR_EXCEL_FIELDS,
  };
};
